import { CustomCellRendererProps } from 'ag-grid-react'

import { useTradeClientsQuery } from '@/react-query/queries/static'

export interface ClientIdCellRendererProps extends CustomCellRendererProps<{
  client_id: number | null
}> {}

export const ClientIdCellRenderer: React.FC<ClientIdCellRendererProps> = ({ value }) => {
  const query = useTradeClientsQuery()

  const label = query.data?.find((t) => t.value === value)?.label ?? value

  return <>{label}</>
}
